import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../environments/environment.type';

@Injectable({ providedIn: 'root' })
export class DynamicTitleStrategy extends TitleStrategy {
  private environment = inject(ENVIRONMENT);

  constructor(private readonly title: Title) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    let finalTitle = '';

    if (!title) {
      finalTitle = 'tmdigital';
    } else {
      finalTitle = `${title} - tmdigital`;
    }

    if (!this.environment.production && this.environment.branchName.includes('BRANCH_NAME')) {
      finalTitle = 'dev: ' + finalTitle;
    }

    if (!this.environment.production && !this.environment.branchName.includes('BRANCH_NAME')) {
      finalTitle = this.environment.branchName + ' - ' + finalTitle;
    }

    this.title.setTitle(finalTitle);
  }
}
